/* @flow */
export default {
  up: 38,
  down: 40,
  left: 37,
  right: 39,
  center: 13,
  back: 46,
};



// WEBPACK FOOTER //
// ./src/commonjs/keyCodes.js